import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { ValidationsModule } from '../validations/validations.module';

import { DynamicCardComponent } from './dynamic-card/dynamic-card.component';
import { DynamicRenderSharedModule } from '../shared/shared.module';
import { CoreBuildingBlockModule } from '../building-block/core-building-block.module';
import { CoreCustomCardsModule } from './custom-cards/custom-cards.module';
import { CardResolverModule } from './resolver/card-resolver.module';
import { CardSharedModule } from './shared/card-shared.module';

@NgModule({
  declarations: [DynamicCardComponent],
  exports: [DynamicCardComponent, CoreCustomCardsModule],
  imports: [
    CommonModule,
    CoreCustomCardsModule,
    CardResolverModule,
    CardSharedModule,
    ValidationsModule,
    CoreBuildingBlockModule,
    DynamicRenderSharedModule
  ]
})
export class CardModule {}
